<template>
  <BaseModalLarge
    :heading="$t('admin.treatwell.photos_modal.heading')"
    :loading="loadingVenue"
    useForm
    small
    testId="task-provide-company-photos"
    @submit="submit"
    @close="close"
  >
    <div>
      <BaseText mb>
        {{ $t('treatwell.images.description') }}
      </BaseText>
      <BaseText v-if="!hasActiveVenue" mb v-test="'stock-image-disclaimer'">
        {{ $t('admin.treatwell.photos_modal.stock_image_disclaimer') }}
      </BaseText>
      <BaseAlert
        color="warning"
        :text="$t('admin.treatwell.photos_modal.alert')"
        :primaryAction="{
          text: $t('admin.treatwell.photos_modal.primary_action'),
          href: photoGuidelinesUrl,
        }"
        mb
      />
      <BaseUpload
        preset="tw-venue-images"
        multiupload
        enforceLandscape
        :minWidth="1920"
        :minHeight="1080"
        dropfield
        @uploadResults="onUpload"
      />
      <BaseImageGallery v-model="images" remove mb />
    </div>
    <template #footer>
      <BaseButton color="inverted" @click="close">
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :loading="isSaving"
        :disabled="
          loadingVenue ||
          images.length > 15 ||
          (hasActiveVenue && images.length < 5) || (!hasActiveVenue && images.length < 3)
        "
        submitForm
        v-test="'company-photos-submit'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </BaseModalLarge>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { flash } from '@/helpers/ui';
import { useI18n } from 'vue-i18n';
import { useMutation, useQuery } from '@vue/apollo-composable';
import { GET_TREATWELL_VENUE, UPDATE_TREATWELL_VENUE } from '../graphql';
import { useTreatwellStore } from '@/stores/treatwell';
import { storeToRefs } from 'pinia';
import { useCompanyStore } from '@/stores/company';
const { hasActiveVenue } = useTreatwellStore();
const { treatwellStatus } = storeToRefs(useTreatwellStore());
const { t } = useI18n();
const router = useRouter();

const { loading: loadingVenue, onResult } = useQuery(GET_TREATWELL_VENUE);
const images = ref<string[]>([]);

onResult(({ data: { treatwellVenue } }) => {
  images.value = treatwellVenue.images || [];
});

const close = () => {
  router.push({
    name: 'treatwell-admin',
  });
};

const {
  mutate: updateSalonPhotos,
  onDone,
  loading: isSaving,
} = useMutation(UPDATE_TREATWELL_VENUE);

const submit = () => {
  treatwellStatus.value.hasPhotos = false;
  updateSalonPhotos({
    input: {
      images: images.value,
    },
  });
};

onDone(() => {
  flash(t('global.flash.treatwell_integration_updated'));
  treatwellStatus.value.hasPhotos = true;
  close();
});

const onUpload = (file: any) => {
  images.value = [...images.value, file.public_id];
};

const { company } = useCompanyStore();
const photoGuidelinesUrl = computed(() => {
  switch (company.country) {
    case 'nl':
      return 'https://salonized.s3.eu-west-1.amazonaws.com/public/Marketplace%20Salon%20Fotografie%20Richtlijnen%20-%20NL.pdf';
    case 'de':
      return 'https://salonized.s3.eu-west-1.amazonaws.com/public/Marketplace%20Salon%20Fotografie%20Leitlinien%20-%20DE.pdf';
  }
  return 'https://salonized.s3.eu-west-1.amazonaws.com/public/Marketplace%20Salon%20Photography%20Guidelines%20-%20EN.pdf';
});
</script>
